export default "__VITE_ASSET__BiAOtH_R__"